import React, { Fragment } from 'react';
import styled from 'styled-components';
import {borderRadius} from '@atlaskit/theme';
import {numberByThousands} from '../../../helpers/string';
import EmailIcon from '@atlaskit/icon/glyph/email';
//import {AppleIcon, AndroidIcon} from '../../../components/Icons';
import SendIcon from '@atlaskit/icon/glyph/send';

const Container = styled.div`
  background: ${props => props.active ? '#42526E' : 'rgba(66,82,110,0.04)'};
  color: ${props => props.active ? '#FFFFFF' : '#42526E'};
  flex: 1;
  text-align: center;
  border-radius: ${borderRadius()}px;
  cursor: pointer;
  margin: 2px;
  padding: 16px 4px;
  user-select: none;
`;

const Title = styled.div`
  font-weight: bold;
  white-space: nowrap;
`;

const Recepients = styled.div`
  font-size: 24px;
  word-spacing: -0.1em;
  white-space: nowrap;
  font-weight: 100;
`;

const Total = styled.div`
  word-spacing: -0.1em;
  white-space: nowrap;
`;

export default ({id, name, recepients, total, ...props})=> (
  <Container {...props}>
    {{
        //1: <AppleIcon />,
        //2: <AndroidIcon />,
        1: <SendIcon />,
        2: <EmailIcon />,
      }[id] || <EmailIcon />
    }
    <Title>{name}</Title>
    {recepients && total && (
      <Fragment>
        <Recepients>{numberByThousands(recepients)}</Recepients>
        <Total>из {numberByThousands(total)}</Total>
      </Fragment>
    )}
  </Container>
)
